import { gql } from "@apollo/client";

export const FETCH_DOCUMENT_SUMMARY = gql`
    query FetchDocumentSummary($documentId: ID!) {
        documentSummary(id: $documentId) {
            id
            text
            type
        }
    }
`; 